

export class FirebaseRoles {


  public static readonly ROLE_ADMINISTRATOR = 'role_administrator';

}
